import { render, staticRenderFns } from "./MypageNickModal.vue?vue&type=template&id=5bb196cc&scoped=true&"
import script from "./MypageNickModal.vue?vue&type=script&lang=js&"
export * from "./MypageNickModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb196cc",
  null
  
)

export default component.exports